import React from "react";
import { Card } from "antd";
import "antd/dist/reset.css";

const courses = [
  {
    name: "Web Development",
    image:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjA3N3wwfDF8c2VhcmNofDJ8fHdlYiUyMGRldmVsb3BtZW50fGVufDB8fHx8MTY5NTE4MTQ4M3ww&ixlib=rb-4.0.3&q=80&w=1600",
    description:
      "Master the complete stack of web development including HTML, CSS, JavaScript, and modern frameworks like React and Node.js.",
  },

  {
    name: "Graphic Design",
    image:
      "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjA3N3wwfDF8c2VhcmNofDJ8fHdlYiUyMGRldmVsb3BtZW50fGVufDB8fHx8MTY5NTE3MzAwM3ww&ixlib=rb-4.0.3&q=80&w=1600",
    description:
      "Explore your creativity and gain proficiency in tools like Adobe Photoshop, Illustrator, and InDesign to bring your designs to life.",
  },

  {
    name: "Digital Marketing",
    image:
      "https://images.unsplash.com/photo-1559526324-593bc073d938?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjA3N3wwfDF8c2VhcmNofDd8fGRpZ2l0YWwlMjBtYXJrZXRpbmd8ZW58MHx8fHwxNjk1MTgyMDEyfDA&ixlib=rb-4.0.3&q=80&w=1600",
    description:
      "Learn all aspects of digital marketing including SEO, social media strategies, content marketing, and Google Ads to drive results.",
  },

  {
    name: "Advanced Excel",
    image:
      "https://images.unsplash.com/photo-1556155092-8707de31f9c4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjA3N3wwfDF8c2VhcmNofDF8fGV4Y2VsfGVufDB8fHx8MTY5NTE4MjA1MXww&ixlib=rb-4.0.3&q=80&w=1600",
    description:
      "Take your Excel skills to the next level with advanced formulas, data analysis techniques, and powerful visualization tools.",
  },

  {
    name: "Tally with GST",
    image:
      "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjA3N3wwfDF8c2VhcmNofDd8fHRhbGx5JTIwYWNjb3VudGluZ3xlbnwwfHx8fDE2OTUxODIwODJ8MA&ixlib=rb-4.0.3&q=80&w=1600",
    description:
      "Become proficient in Tally ERP9 and manage accounting and GST transactions seamlessly for businesses.",
  },

  {
    name: "DCA/ADCA (Advanced Diploma in Computer Applications)",
    image:
      "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjA3N3wwfDF8c2VhcmNofDJ8fGNvbXB1dGVyJTIwYXBwbGljYXRpb258ZW58MHx8fHwxNjk1MTgyMTY1fDA&ixlib=rb-4.0.3&q=80&w=1600",
    description:
      "Gain comprehensive training in computer applications, covering MS Office, Internet, and programming essentials.",
  },

  {
    name: "English Spoken",
    image:
      "https://images.pexels.com/photos/4302084/pexels-photo-4302084.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Improve your spoken English fluency and communication skills with practical lessons in grammar, vocabulary, and conversation.",
  },
];

const { Meta } = Card;

const Course = () => {
  return (
    <div>
      <h1 className="text-center font-bold text-2xl mt-5 mb-5"> Our Courses</h1>

      <div className="mt-4 flex flex-wrap ml-10 ">
        {courses.map((course, index) => (
          <div
            key={index}
            className="cart1 mt-5 mr-5 w-[300px] h-[350px] rounded-md text-white flex flex-col justify-between p-4 shadow-lg transform transition-transform hover:scale-105"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)), url(${course.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="flex-grow">
              <h1 className="text-xl text-center font-bold text-white drop-shadow-lg">
                {/* Web Design */}
                {course.name}
              </h1>
              <p className="mt-2 text-sm text-center text-gray-300">
                {course.description}
              </p>
            </div>
            <p className="text-center font-bold">For more Infomation </p>
            <button className="bg-gradient-to-r from-blue-500 to-blue-700 p-3 rounded-md font-bold text-white mt-4 transition-colors hover:bg-blue-600">
              Visit Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Course;
